import React, { useEffect } from 'react';
import { NavLink, useSearchParams } from 'react-router-dom';

import { list as listOrders } from '../../apis/orders';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { usePagination } from '../../hooks/usePagination';
import { useApiQuery } from '../../hooks/useApiQuery';

import { AdminBreadcrumb } from '../../components/admin/AdminBreadcrumb';
import { OrdersList } from '../../components/orders/OrdersList';
import { useForm } from '../../hooks/useForm';

export const AdminOrdersPage = () => {
    useDocumentTitle('Admin Orders');

    const [searchParams, setSearchParams] = useSearchParams();
    const initialDate = searchParams.get('date') || '';
    const initialUser = searchParams.get('user') || '';
    const initialStatus = searchParams.get('status') || '';

    const [values, handleInputChange, reset] = useForm({
        date: initialDate,
        user: initialUser,
        status: initialStatus
    });
    const { date, user, status } = values;

    const { pagination, setPagination, handlers } = usePagination({
        page: 1,
        size: 5,
        mode: 'admin'
    });
    const orders = useApiQuery(listOrders, pagination);

    useEffect(() => {
        setPagination({
            page: 1,
            size: 5,
            mode: 'admin',
            date,
            user,
            status
        });
    }, [initialDate, initialUser, initialStatus]);

    const handleSubmitFilters = (event) => {
        event.preventDefault();
        setSearchParams({ date, user, status });
    };

    const handleResetFilters = () => {
        reset({ date: '', user: '', status: '' });
        setSearchParams({});
    };

    return (
        <div className="admin-orders-page mb-5">
            <h1 className="h3">Orders</h1>
            <AdminBreadcrumb>
                <NavLink className="breadcrumb-item text-decoration-none" to="/admin/orders">
                    Orders
                </NavLink>
            </AdminBreadcrumb>
            <div className="row mb-3">
                <form
                    onSubmit={handleSubmitFilters}
                    onReset={handleResetFilters}
                    className="col-md-9 col-lg-10">
                    <div className="row">
                        <div className="col-md-6 col-lg-3 mb-3 mb-md-3 mb-lg-0">
                            <input
                                name="date"
                                value={date}
                                placeholder="Date"
                                className="form-control"
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="col-md-6 col-lg-4 mb-3 mb-md-3 mb-lg-0">
                            <input
                                name="user"
                                value={user}
                                placeholder="User"
                                className="form-control"
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="col-md-6 col-lg-3 mb-3 mb-md-3 mb-lg-0">
                            <input
                                name="status"
                                value={status}
                                placeholder="Status"
                                className="form-control"
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="col-md-6 col-lg-2 mb-3 mb-md-3 mb-lg-0">
                            <div className="d-grid">
                                <div className="btn-group">
                                    <button className="btn btn-outline-secondary" type="reset">
                                        <span className="fas fa-eraser fa-fw"></span>
                                    </button>
                                    <button className="btn btn-outline-primary" type="submit">
                                        <span className="fas fa-search fa-fw"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div className="col-md-3 col-lg-2 mb-3 mb-md-3 mb-lg-0">
                    <div className="d-grid">
                        <NavLink to="/admin/orders/create" className="btn btn-primary">
                            New
                        </NavLink>
                    </div>
                </div>
            </div>
            <OrdersList onReset={handleResetFilters} {...{ ...orders, handlers }} />
        </div>
    );
};
